import React from 'react'
import {
    StyledCardActivity,
    StyledCardActivityTitle,
    StyledCardActivityValues
} from './styled'

const CardActivity = ({ title, values, noMargin }) => {
    return (
        <StyledCardActivity noMargin={noMargin}>
            <StyledCardActivityTitle>{title}</StyledCardActivityTitle>
            <StyledCardActivityValues>{values}</StyledCardActivityValues>
        </StyledCardActivity>
    )
}

export default CardActivity